import { z } from 'zod';

import { DeclarationStatus, ReportStatus, TemplateType } from '@e-origin/shared';

import { AdminBatchStatisticsSchema } from './AdminBatchStatisticsSchema';
import { AdminBatchStatusSchema } from './AdminBatchStatusSchema';

export const AdminBatchSchema = z.object({
  _id: z.any(),
  name: z.string(),
  counter: z.number(),
  filename: z.string(),
  template: z
    .object({
      _id: z.any(),
      name: z.string(),
      version: z.number(),
    })
    .optional(),
  templateType: z.nativeEnum(TemplateType).optional(),
  isExport: z.boolean().nullable().optional(),
  status: AdminBatchStatusSchema,
  statistics: AdminBatchStatisticsSchema.optional(),
  broker: z.string().optional(),
  reports: z
    .object({
      customsReport: z
        .object({
          status: z.nativeEnum(ReportStatus).optional(),
          lrns: z
            .array(
              z.object({
                lrn: z.string(),
                statuses: z.array(z.object({ status: z.nativeEnum(DeclarationStatus).optional(), count: z.number().optional() })).optional(),
              }),
            )
            .optional(),
        })
        .optional(),
      utbReport: z
        .object({
          status: z.nativeEnum(ReportStatus).optional(),
          lrns: z
            .array(
              z.object({
                lrn: z.string(),
                statuses: z.array(z.object({ status: z.nativeEnum(DeclarationStatus).optional(), count: z.number().optional() })).optional(),
              }),
            )
            .optional(),
        })
        .optional(),
    })
    .optional(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
  virtuals: z
    .object({
      hasFileInCloud: z.boolean().optional(),
      missingSequence1Lrns: z.array(z.string()).optional(),
    })
    .optional(),
});

export type AdminBatch = z.infer<typeof AdminBatchSchema>;
